@if (isLoading()) {
  <div class="ai-loading-container select-none">
    <!-- Timer Display -->
    <div class="timer-display">
      <div class="timer-icon">
        <i class="pi pi-clock"></i>
      </div>
      <div class="timer-text">{{ elapsedTimeFormatted() }}</div>
    </div>

    <!-- Action Buttons -->
    <div class="cancel-button-container flex gap-2">
      <p-button 
        label="Stop Generation" 
        icon="pi pi-times"
        severity="danger"
        [outlined]="true"
        size="small"
        (click)="onStopGeneration()">
      </p-button>
      <p-button 
        label="Continue in Background" 
        icon="pi pi-arrow-right"
        severity="secondary"
        [outlined]="true"
        size="small"
        (click)="onHideInBackground()">
      </p-button>
    </div>

    <div class="ai-stage">
      <!-- Orbit layer (cases 1 / 3 / 4) -->
      @if (phase === 1 || phase === 3) {
        <div
          class="orbit-layer"
          [class.is-collapsing]="phase === 1 && isCollapsing">

          <!-- CASE 1 -->
          @if (phase === 1) {
            @for (item of dataItemsCase1; track item.label; let i = $index) {
              <!-- lines -->
              <div
                class="orbit-line"
                [ngStyle]="orbitCardVars(i, dataItemsCase1.length, getOrbitRadiusForCount(dataItemsCase1.length), getLineDelayMs(i, dataItemsCase1.length))">
              </div>

              <!-- cards -->
              <div
                class="orbit-card-wrap"
                [ngStyle]="orbitCardVars(i, dataItemsCase1.length, getOrbitRadiusForCount(dataItemsCase1.length), getLineDelayMs(i, dataItemsCase1.length))"
                [style.animation-delay.ms]="i * 60">
                <div class="orbit-card orbit-card--case1 bg-white/95 backdrop-blur-lg rounded-2xl border-2 border-primary-200 shadow-lg flex items-center gap-3 p-3 min-w-[240px] max-w-[240px]">
                  <!-- Icon -->
                  <div 
                    class="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
                    [ngClass]="'icon-' + item.color">
                    <i [class]="item.icon + ' text-white text-lg'"></i>
                  </div>
                  <!-- Text -->
                  <div class="flex-1 min-w-0">
                    <div class="text-[0.7rem] font-bold uppercase tracking-wider text-grey-500 leading-tight mb-1">
                      {{ item.label }}
                    </div>
                    <div class="text-sm font-semibold text-grey-900 leading-snug break-words">
                      {{ item.value }}
                    </div>
                  </div>
                </div>
              </div>
            }
          }

          <!-- CASE 3 -->
          @if (phase === 3) {
            @for (exName of dataItemsCase3; track exName; let i = $index) {
              <div
                class="orbit-line orbit-line--thin"
                [ngStyle]="orbitCardVars(i, dataItemsCase3.length, getOrbitRadiusForCount(dataItemsCase3.length), getLineDelayMs(i, dataItemsCase3.length))">
              </div>  
              <div
                class="orbit-card-wrap"
                [ngStyle]="orbitCardVars(i, dataItemsCase3.length, getOrbitRadiusForCount(dataItemsCase3.length), getLineDelayMs(i, dataItemsCase3.length))">
                <div class="bg-white/95 backdrop-blur-lg rounded-2xl border-2 border-primary-200 shadow-lg flex items-center">
                  <div class="orbit-card__chip">{{ exName }}</div>
                </div>
              </div>
            }
          }
        </div>
      }

    <!-- AI Brain/Logo (center) - shown in all phases -->
    <div class="ai-brain-container">
      <div class="brain-circle" [class.brain-absorbing]="phase === 1 && isCollapsing">
        <img src="vixey-logo.png" alt="Vixey" class="h-12 w-12 object-contain" />
      </div>
      
      <!-- Orbiting Dots & Rings for phases 2 & 4 -->
      @if (phase === 2 || phase === 4) {
        <div class="expanding-ring expanding-ring-1"></div>
        <div class="expanding-ring expanding-ring-2"></div>
      }
    </div>

    <!-- Messages area (case 2 & case 4) -->
    @if (phase === 2) {
      <div class="ai-messages ai-messages--fixed">
        <!-- Thought bubble dots pointing to brain -->
        <div class="thought-bubbles">
          <div class="thought-bubble thought-bubble--5"></div>
          <div class="thought-bubble thought-bubble--4"></div>
          <div class="thought-bubble thought-bubble--3"></div>
          <div class="thought-bubble thought-bubble--2"></div>
          <div class="thought-bubble thought-bubble--1"></div>
        </div>
        
        <div class="ai-message-card" [class.is-hidden]="!messageVisible">
          <div class="ai-message-title">Reasoning</div>
          <div class="ai-message-text message-switch-animation" [innerHTML]="dataItemsCase2[case2Index]?.label"></div>
        </div>
      </div>
    }

    @if (phase === 4) {
      <div class="ai-messages ai-messages--fixed">
        <!-- Thought bubble dots pointing to brain -->
        <div class="thought-bubbles">
          <div class="thought-bubble thought-bubble--5"></div>
          <div class="thought-bubble thought-bubble--4"></div>
          <div class="thought-bubble thought-bubble--3"></div>
          <div class="thought-bubble thought-bubble--2"></div>
          <div class="thought-bubble thought-bubble--1"></div>
        </div>
        
        <div class="ai-message-card ai-message-card--compact" [class.is-hidden]="!messageVisible">
          <div class="ai-message-title">Finalizing</div>
          <div class="ai-message-text message-switch-animation" [innerHTML]="dataItemsCase4[case4Index]?.label"></div>
        </div>
      </div>
    }
    </div>
  </div>
}
